import api from './api';

/**
 * Q&A Service
 * Handles all API calls related to the Q&A system
 */

const qaService = {
  /**
   * Ask a question to the Q&A system
   * @param {string} query - The question to ask
   * @returns {Promise} Response with answer and sources
   */
  askQuestion: async (query) => {
    try {
      const response = await api.post('/api/qa/query', { query });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get list of all indexed companies
   * @returns {Promise} List of company names
   */
  getIndexedCompanies: async () => {
    try {
      const response = await api.get('/api/qa/companies');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get available quarters for a specific company
   * @param {string} companyName - Name of the company
   * @returns {Promise} List of quarters
   */
  getCompanyQuarters: async (companyName) => {
    try {
      const response = await api.get(`/api/qa/quarters/${encodeURIComponent(companyName)}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get list of all indexed calls
   * @param {Object} filters - Optional filters (company_name, quarter, year)
   * @returns {Promise} List of indexed calls
   */
  getIndexedCalls: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.company_name) params.append('company_name', filters.company_name);
      if (filters.quarter) params.append('quarter', filters.quarter);
      if (filters.year) params.append('year', filters.year);
      
      const response = await api.get(`/api/indexed_calls?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Trigger indexing for a transcription
   * @param {string} transcriptionJobId - The transcription job ID to index
   * @returns {Promise} Indexing job details
   */
  indexTranscription: async (transcriptionJobId) => {
    try {
      const response = await api.post('/api/index_transcription', {
        transcription_job_id: transcriptionJobId
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get indexing job status
   * @param {string} indexingJobId - The indexing job ID
   * @returns {Promise} Indexing job status
   */
  getIndexingStatus: async (indexingJobId) => {
    try {
      const response = await api.get(`/api/index_status/${indexingJobId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default qaService;

